import React, { Component } from 'react';
import { Layout } from 'antd';
import styles from './Footer.less';

const { Footer } = Layout;

class PublicFooter extends Component {
  render() {
    return (
      <Footer className={styles.footer}>
        <div className={styles.textContainer}>
          <span>极熵</span> &nbsp;&nbsp;
          <span>2014-{new Date().getFullYear()}</span> &nbsp;&nbsp;
          <span>© All rights reserved</span>
        </div>
      </Footer>
    );
  }
}

export default PublicFooter;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js